export const DADOS_CADASTRAIS_PF_DTO = {
  "cpf": "85122220425",
  "codigoSituacaoCadastral": 0,
  "dataInscricao": "1994-04-25",
  "situacaoCadastral": "REGULAR",
  "dataBaixa": null,
  "nome": "HVITRL XZIOLH ILXSZ",
  "dataNascimento": "1972-12-05",
  "cpfCancelado": [],
  "cpfAtivo": "",
  "anoObito": "0000",
  "endereco": {
    "tipoLogradouro": "",
    "logradouro": "I ORWRZ YLIQZ",
    "numero": "524",
    "complemento": "APTO 101 BLOCO 2",
    "bairro": "STELLA MARIS",
    "cep": "41600550",
    "municipio": {
      "codigo": "3849",
      "nome": "SALVADOR",
      "uf": "BA"
    }
  },
  "unidade": {
    "codigo": "0518000",
    "nome": "DERAT FEIRA DE SANTANA-BA"
  }
};
